import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${DefaultValue.BorderRadius};
  background: ${Color.White};
  box-shadow: 0 2px 1px ${Color.Grey150};
`
